/**
 * NextLocaleHelper is helper that is used in getLabelsByStorageKey function only for the Next.js projects
 * This means if the window object is undefined (IS_CLIENT variable is false).
 *
 * NextLocaleHelper.locale should be set with the value that Next.js router provide, before page generation has started
 *
 * If the locale is not set then en_gb is default language.
 * That will result that all calls of the function getLabelFromStorage will return English strings
 *
 *
 * https://nextjs.org/docs/advanced-features/i18n-routing#accessing-the-locale-information
 * When pre-rendering pages with getStaticProps or getServerSideProps, the locale information is provided in the context
 * provided to the function.
 *
 * When leveraging getStaticPaths, the configured locales are provided in the context parameter of the function under
 * locales and the configured defaultLocale under defaultLocale.
 *
 * @example
 * // set nextJSRouterLocale to the NextLocaleHelper.locale
 * NextLocaleHelper.locale = nextJSRouterLocale.
 */
class NextLocaleHelper {
    static set locale(locale) {
        NextLocaleHelper._locale = locale;
    }
    static get locale() {
        return NextLocaleHelper._locale;
    }
}
export default NextLocaleHelper;
//# sourceMappingURL=NextLocaleHelper.js.map